import React from "react";
import { Navigate } from "react-router-dom";
import { useRole } from "../../context/RoleContext";

/**
 * Restringe uma rota com base na role do usuário autenticado.
 *
 * Pressupõe que a rota já esteja envolvida por <PrivateRoute>, ou seja,
 * a presença de token já foi validada antes. Aqui só decidimos se o
 * perfil tem acesso àquele caminho específico.
 *
 * @param {string[]} allowedRoles - lista de roles autorizadas. Se a role
 *   atual não estiver nessa lista, o usuário é redirecionado para
 *   `redirectTo`.
 * @param {string} redirectTo - rota usada quando o acesso é negado.
 */
const RoleRoute = ({ allowedRoles = [], redirectTo = "/app/dashboard", children }) => {
  const { role } = useRole();

  if (!allowedRoles.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RoleRoute;
